import { render, staticRenderFns } from "./PostcodeAdditionalFeeListItem.vue?vue&type=template&id=8e49327e&scoped=true&"
import script from "./PostcodeAdditionalFeeListItem.vue?vue&type=script&lang=js&"
export * from "./PostcodeAdditionalFeeListItem.vue?vue&type=script&lang=js&"
import style0 from "./PostcodeAdditionalFeeListItem.vue?vue&type=style&index=0&id=8e49327e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e49327e",
  null
  
)

export default component.exports